import axios from 'axios'

const state = {
  untaggedCount: 0,
  taggedCount: 0,
  checkedOutUsers: [],
  byProject: []
}

const mutations = {
  setStatus (state, data) {
    state.untaggedCount = data.untagged_count
    state.taggedCount = data.tagged_count
    state.checkedOutUsers = data.checked_out_users
    state.byProject = data.by_project || []
  }
}

const actions = {
  fetchStatus (context) {
    return axios.get('/api/photos/status/')
      .then(response => {
        context.commit('setStatus', response.data)
      })
      .catch(e => { console.log(e) })
  },
  unassignUser (context, userId) {
    return axios.post('/api/photos/unassign_user/', { user_id: userId })
      .then(response => {
        context.commit('setStatus', response.data)
      })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  mutations,
  actions
}
